import { Tooltip } from "antd";
import React from "react";
import { GetAntIcon } from "../utils/ant_icons";
import { noSubscriptionMessage } from "./LockedModuleTooltip";

interface TooltipI {
	title: string;
	placement:
		| "top"
		| "bottom"
		| "left"
		| "right"
		| "topLeft"
		| "topRight"
		| "bottomLeft"
		| "bottomRight"
		| "leftTop"
		| "leftBottom"
		| "rightTop"
		| "rightBottom";
}

interface TabButtonProps {
	identifier: string;
	label: string;
	icon: any;
	activePage: string;
	setActivePage: React.Dispatch<React.SetStateAction<string>>;
	tooltip?: TooltipI;
	disabled?: boolean;
	lock?: boolean;
	showLabel?: boolean;
	// How many items the tab holds, shown after the label.
	count?: number;
}

function TabButton({
	identifier,
	label,
	icon,
	activePage,
	setActivePage,
	tooltip,
	disabled,
	lock = false,
	showLabel = true,
	count,
}: TabButtonProps) {
	const buttonContent = (
		<div
			className={activePage === identifier ? "project-active-button" : ""}
			style={{
				display: "flex",
				padding: "4px 15px",
				gap: "8px",
				cursor: disabled || lock ? "not-allowed" : "pointer",
				opacity: disabled || lock ? 0.5 : 1,
			}}
			onClick={() => {
				if (!disabled && !lock) {
					setActivePage(identifier);
				}
			}}
		>
			{icon}
			{showLabel && (
				<span
					style={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						display: "inline-block",
					}}
				>
					{label}
				</span>
			)}
			{showLabel && count !== undefined && (
				<span
					style={{
						alignSelf: "center",
						padding: "0 8px",
						borderRadius: "999px",
						background: "color-mix(in srgb, currentColor 20%, transparent)",
						fontSize: "12px",
						lineHeight: "20px",
					}}
				>
					{count}
				</span>
			)}
			{lock && <span>{GetAntIcon("lock")}</span>}
		</div>
	);

	if (!showLabel) {
		return (
			<Tooltip title={label} placement="top">
				{buttonContent}
			</Tooltip>
		);
	}

	return (
		<Tooltip
			{...(lock ? { title: noSubscriptionMessage, placement: "top" } : tooltip)}
		>
			{buttonContent}
		</Tooltip>
	);
}

export default TabButton;
